import React from "react";
import cn from "classnames";
import { Heading } from "@telia/teddy";
import { SellingPoints } from "../../../../../../models";
import SubscriptionFeature from "./SubscriptionFeature";
import "./SubscriptionFeatures.less";
import type { UspCardConfiguration } from "../UspList/uspCardPresentation";

interface Props extends UspCardConfiguration {
    className?: string;
    heading?: string;
    items?: SellingPoints[];
}

const SubscriptionFeatures: React.FC<Props> = ({ className, items, variant, layout, heading }) => {
    return (
        <div className={cn("subscription-features", className)}>
            {heading && (
                <div className="subscription-features__header">
                    <Heading mb="100" as="h2" variant="title-400">
                        {heading}
                    </Heading>
                </div>
            )}
            <div className="subscription-features__grid">
                {items?.map((item) => (
                    <SubscriptionFeature key={item.heading} item={item} variant={variant} layout={layout} />
                ))}
            </div>
        </div>
    );
};

export default SubscriptionFeatures;
